var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.307,
    height: 11.309,
    viewBox: "0 0 11.307 11.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30451",
    "data-name": "Path 30451",
    d: "M24.8,16.9a5.935,5.935,0,0,0-3.354-.954.554.554,0,0,0-.572.548v1.674a.782.782,0,0,0,.628.784.755.755,0,0,0,.881-.744v-.68a4.141,4.141,0,0,1,2.8,1.922,4.1,4.1,0,0,1-.066,4.4,4.141,4.141,0,1,1-6.818-4.7.754.754,0,1,0-1.229-.872A5.657,5.657,0,1,0,24.8,16.9Zm-3.552,5.079a.565.565,0,1,0,.8-.8L20.187,19.3a.565.565,0,1,0-.8.8Z",
    transform: "translate(-15.998 -15.95)",
    fill: "#272431"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.a7ea52d4c4cb0700954855f6ba85df90.svg";
export { ForwardRef as ReactComponent };